import { formatCountdown } from './constants';

import type { DebugDatasetInfo, DebuggerData } from '../types';

export function ConnectionDot({
  status,
  source,
  wsStatus,
  dataUpdatedAt,
  fallbackPollIntervalMs,
  now,
}: {
  status: DebugDatasetInfo['status'];
  source?: DebugDatasetInfo['source'];
  wsStatus: DebuggerData['wsStatus'];
  dataUpdatedAt?: number;
  fallbackPollIntervalMs: number | false;
  now: number;
}) {
  let dotClass: string;
  let tooltipText: string;

  if (status === 'error') {
    dotClass = 'bg-[var(--text-color-critical)]';
    tooltipText = 'Error';
  } else if (status === 'loading') {
    dotClass = 'bg-[var(--text-color-info)] animate-pulse';
    tooltipText = 'Loading…';
  } else if (status === 'idle') {
    dotClass = 'bg-[var(--text-color-tertiary)]';
    tooltipText = 'Idle';
  } else if (wsStatus === 'connected') {
    // Loaded + WS connected → streaming
    dotClass = 'bg-[var(--text-color-positive)] animate-pulse';
    tooltipText =
      source === 'trpc'
        ? 'Streaming (initial load via tRPC)'
        : 'Streaming via WebSocket';
  } else if (wsStatus === 'connecting') {
    dotClass = 'bg-[var(--text-color-info)] animate-pulse';
    tooltipText = 'WebSocket connecting…';
  } else {
    // Loaded + WS disconnected → polling via tRPC
    const countdown = formatCountdown(
      dataUpdatedAt,
      fallbackPollIntervalMs,
      now
    );
    dotClass = 'bg-[var(--text-color-caution)] animate-pulse';
    tooltipText = countdown
      ? `Polling via tRPC · next in ${countdown}`
      : 'Polling via tRPC';
  }

  return (
    <span title={tooltipText} className="shrink-0">
      <span
        aria-hidden="true"
        className={`block h-2.5 w-2.5 rounded-full ${dotClass}`}
      />
      <span className="sr-only">{tooltipText}</span>
    </span>
  );
}
